import * as React from 'react';
import { Icon } from '@fluentui/react';

import { PBTFlagColors } from '../../../Services/PBTConstants';
import type { PBTFlag } from '../../../Interfaces/IPBTCase';
import { flagBadgeStyles, getFlagBadgeItemStyles } from './FlagBadge.styled';

interface FlagBadgeProps {
  flags: PBTFlag[];
}

export const FlagBadge: React.FC<FlagBadgeProps> = ({ flags }) => {
  if (!flags || flags.length === 0) {
    return <span className={flagBadgeStyles.empty}>—</span>;
  }
  return (
    <span className={flagBadgeStyles.container}>
      {flags.map((flag) => {
        const cfg = PBTFlagColors[flag];
        if (!cfg) return null;
        const itemStyles = getFlagBadgeItemStyles(cfg.background, cfg.color);
        return (
          <span key={flag} className={itemStyles.badge}>
            <Icon iconName={cfg.icon} /> {flag}
          </span>
        );
      })}
    </span>
  );
};
